import React, { memo } from 'react';
import './ViewControls.scss';
function PreviewControls({ children, className = '' }) {
    return React.createElement("div", { className: `${className}` }, children);
}
export default memo(PreviewControls);
